export const faqContent = [
    {
        title: "Launching Bank Agent App in Alexa",
        head: "As with any other Alexa app, you launch the app by invoking the app's name.",
        question: "Alexa, open Bank Agent!",
        response: "Hi [user]. You can say 'Get balance on my checking account. Or just say help, or demo.' "
    },
    {
        title: "Getting balance on all accounts from a bank",
        head: "Asking balance is simple! Just say the name of the bank.",
        question: "Get balance on my Bank of America accounts.",
        response: "You have two accounts in Bank of America. The balance in your Bank of America credit card is $1,323, and the balance in your Bank of America checkings is $2,365"
    },
    {
        title: "Getting balance on all accounts of a specific type.",
        head: "Conversely, you can also get information on all accounts of a specific type (i.e. checking, savings, credit.)",
        question: "Get balance on my savings accounts.",
        response: "The balance in your Capital One savings account is $19,537. The balance on your Suntrust savings account is $4,902."
    },

    {
        title: "Getting balance using name of the bank and account type.",
        head: "You can get more specific. Just say the name of the institution and the type of the account.",
        question: "Get balance on my Bank of America credit card.",
        response: "The balance in your Bank of America credit card is $1,323."
    }
];